export const showValidationErrorMessage = function (error, element) {
    error.addClass("form-error-message");
    // Select the parent wrapper - either input-wrapper or select-wrapper
    const errorWrapper = element.parents(".field").find(".field__error");
    // Insert your custom error
    error.appendTo(errorWrapper).show();
    errorWrapper.slideDown(200);
};

window.showValidationErrorMessage = showValidationErrorMessage;